// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1ttNm","tab":"ProcedureTabs_tab__2fbIb"};